import { DialogTitle, Typography } from '@mui/material';
import { ResponsibilityAreaPoi } from './PoiDialog.types';

export const ResponsibilityDialogContent = (
  props: ResponsibilityAreaPoi,
): JSX.Element => {
  const { title } = props;

  return (
    <DialogTitle id="alert-dialog-title">
      <Typography
        component="span"
        variant="body2"
        sx={{
          fontWeight: 'bold',
        }}
      >
        {title}
      </Typography>
    </DialogTitle>
  );
};
